export default "__VITE_ASSET__CdzU5eMr__"